
export default function Footer() {
  const handleTopPageClick = () => {
    window.open('https://www.bizchain.co.jp/', '_blank');
  };

  return (
    <footer className="py-12 px-4 bg-gray-800 text-white">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col items-center space-y-6">
          <button
            onClick={handleTopPageClick}
            className="hover:opacity-80 transition-opacity duration-300 cursor-pointer bg-transparent border-none"
          >
            <img 
              src="https://static.readdy.ai/image/33e4d9a6aa73ec1d4a454a3f4917fe46/fab3f1d05ed2f8bcebcebeebc3a84df1.png"
              alt="BIZCHAIN"
              className="h-10 w-auto"
            />
          </button>
          
          <p className="text-sm text-gray-400 text-center mt-8">
            Copyright © BIZ CHAIN . All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
